<template>
  <div>
      <h3 v-if="msguser && msguser != ''" style="color:green;text-shadow:0px 0px 3px #a5a5a5">
        {{ msguser }}
      </h3>
      <div v-if="booking.iam == 'inviter'">

          <!-- VIEWING CONFIRMATION -->
          <div class="booking__confirmation">
            <div>
              <div class="booking__confirmation__icon"><i class="ico ico-checkmark"></i></div>
              <p>Viewing confirmed: </p>
              <p>{{ niceDate(booking.booking.date_suggested) }}</p>
              <p>{{ getAddress(false,true) }}</p>
              <!--
                <h4 v-if="booking.booking.status == 'pending'">
                  Waiting for confirmation from the applicant...
                </h4>
              -->
              <!-- <button @click.prevent="processActions('confirm')">Confirm at {{ niceDate(booking.booking.date_suggested) }}</button>
              <button @click.prevent="processActions('newsuggest')">Or suggest new date</button> -->
              <div class="text-center booking__confirmation__add-to-calendar">Add to calendar</div>
              <div class="mdc-layout-grid mdc-layout-grid__inner booking__calendar_root">
                <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone booking__calendar">
                  <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('ical')"><img class="booking__calendar-buttons__icon" src="/static/img/ical-icon.jpg"><br>iCal</div>
                </div>
                <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone booking__calendar">
                  <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('ical')"><img class="booking__calendar-buttons__icon" src="/static/img/outlook-icon.png"><br>Outlook</div>
                </div>
                <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone booking__calendar">
                  <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('google')"><img class="booking__calendar-buttons__icon" src="/static/img/GoogleCalendar-icon.png"><br>Google Calendar</div>
                </div>
                <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone booking__calendar">
                  <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('yahoo')"><img class="booking__calendar-buttons__icon" src="/static/img/yahoo-icon.png"></div>
                </div>
              </div>
            </div>

            <div class="booking__confirmation__applicant-details">
              <span>Applicant <u>{{ (booking.user && booking.user.fullName) ? booking.user.fullName : booking.booking.profileExtra.name }}</u> {{ (booking.user && booking.user.phone) ? booking.user.phone : '' }}</span>
              <br><span>{{ niceDate(booking.booking.date_suggested,false,true) }}</span>
            </div>

            <div class="booking__confirmation__cancel">
              <!-- <div @click.prevent="getDirections()" class="btn btn--bordered">Get directions</div> -->
              <div @click.prevent="processActions('cancel')" class="btn btn--bordered booking__btn">Cancel Viewing</div>
            </div>

            <div class="booking__confirmation__notice">
              <span class="subtle-text font-smaller">
                The Applicant has been notified that the viewing is confirmed and has the full address of the property with directions
              </span>
            </div>

          </div>
      </div>

      <div class="booking__confirmation" v-else>
        <div v-if="booking.booking.status == 'pending'">
          <div class="btn btn--bordered booking__btn" @click.prevent="processActions('confirm')">I'll be there</div>
          <div class="text-center font-smaller">Or ask me again</div>
          <div class="booking__ask-again-btn-wrapper">
            <button class="booking__ask-again-btn" @click.prevent="processActions('later',30)">In 30min</button> <button class="booking__ask-again-btn" @click.prevent="processActions('later',60)">In 1hour</button> <button class="booking__ask-again-btn" @click.prevent="processActions('later',(60*24))">Tomorrow</button>
          </div>
          <div class="booking__confirmation__applicant-details">
            <span>Agent {{ (booking.agent && booking.agent.name) ? booking.agent.name : 'Agent' }} {{ (booking.agent && booking.agent.phone) ? booking.agent.phone : '' }}</span>
            <br><span>{{ niceDate(booking.booking.date_suggested) }}</span>
          </div>

          <div class="booking__confirmation__buttons">
            <!-- <div @click.prevent="getDirections()" class="btn btn--bordered">Get directions</div> -->
            <div @click.prevent="processActions('cancel')" class="btn btn--bordered booking__btn booking__cancel-btn">Cancel Viewing Request</div>
          </div>

          <div class="booking__confirmation__applicant-details">
            <span class="subtle-text font-smaller">
            The Agent has been notified that the viewing is confirmed and has the full address of the property with directions
            </span>
          </div>
        </div>

        <div class="booking__confirmation__just-confirmed" v-else-if="booking.booking.status == 'justconfirmed'">
            <h3>Thank you {{ booking.user.fullName ? booking.user.fullName : booking.user.fullName }}, your viewing is confirmed.</h3>
            <br>
            <p>{{ niceDate(booking.booking.date_suggested) }}</p>
            <p>{{ getAddress(false,false,true,false,true) }}</p>

            <div class="text-center booking__confirmation__add-to-calendar">Add to calendar</div>
            <div class="mdc-layout-grid mdc-layout-grid__inner booking__calendar_root">
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone booking__calendar">
                <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('ical')"><img class="booking__calendar-buttons__icon" src="/static/img/ical-icon.jpg"><br>iCal</div>
              </div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone booking__calendar">
                <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('ical')"><img class="booking__calendar-buttons__icon" src="/static/img/outlook-icon.png">Outlook</div>
              </div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone booking__calendar">
                <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('google')"><img class="booking__calendar-buttons__icon" src="/static/img/GoogleCalendar-icon.png">Google Calendar</div>
              </div>
              <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone booking__calendar">
                <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('yahoo')"><img class="booking__calendar-buttons__icon" src="/static/img/yahoo-icon.png"></div>
              </div>
            </div>

            <div class="booking__confirmation__buttons">
              <!-- <div @click.prevent="getDirections()" class="btn btn--bordered">Get directions</div> -->
              <div @click.prevent="getDirections()" class="btn btn--bordered booking__cancel-btn">GET DIRECTIONS</div>
            </div>
            <br>
            <span class="text-italic">We will email you a copy of the confirmation</span>
        </div>

        <div v-else>
          <div class="booking__confirmation__icon"><i class="ico ico-checkmark"></i></div>
          <p>Viewing confirmed: </p>
          <p>{{ niceDate(booking.booking.date_suggested) }}</p>
          <p>{{ getAddress(false,true) }}</p>
          <!-- <button @click.prevent="processActions('confirm')">Confirm at {{ niceDate(booking.booking.date_suggested) }}</button>
          <button @click.prevent="processActions('newsuggest')">Or suggest new date</button> -->
          <div class="text-center booking__confirmation__add-to-calendar">Add to calendar</div>
          <div class="mdc-layout-grid mdc-layout-grid__inner booking__calendar_root">
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone booking__calendar">
              <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('ical')"><img class="booking__calendar-buttons__icon" src="/static/img/ical-icon.jpg"><br>iCal</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone booking__calendar">
              <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('ical')"><img class="booking__calendar-buttons__icon" src="/static/img/outlook-icon.png">Outlook</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone booking__calendar">
              <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('google')"><img class="booking__calendar-buttons__icon" src="/static/img/GoogleCalendar-icon.png">Google Calendar</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-3 mdc-layout-grid__cell--span-2-phone booking__calendar">
              <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('yahoo')"><img class="booking__calendar-buttons__icon" src="/static/img/yahoo-icon.png"></div>
            </div>
          </div>

          <div class="booking__confirmation__applicant-details">
            <span>Agent {{ (booking.agent && booking.agent.name) ? booking.agent.name : 'Agent' }} {{ (booking.agent && booking.agent.phone) ? booking.agent.phone : '' }}</span>
            <br><span>{{ niceDate(booking.booking.date_suggested,false,true) }}</span>
          </div>

          <div class="booking__confirmation__buttons">
            <!-- <div @click.prevent="getDirections()" class="btn btn--bordered">Get directions</div> -->
            <div @click.prevent="processActions('cancel')" class="btn btn--bordered booking__btn">Cancel Viewing</div>
          </div>

          <div class="booking__confirmation__applicant-details">
            <span class="subtle-text font-smaller">
            The Agent has been notified that the viewing is confirmed and has the full address of the property with directions
            </span>
          </div>
        </div>

        </div>
      </div>
  </div>
</template>
<script>
import api from '@/libs/api.js';

function dtstamp(date) {
  let redate = date ? new Date(date) : new Date();
  let strout = redate.getFullYear();
  strout += ("0" + (redate.getMonth()+1)).slice(-2);
  strout += ("0" + redate.getDate()).slice(-2);
  strout += "T";
  strout += ("0" + redate.getHours()).slice(-2);
  strout += ("0" + redate.getMinutes()).slice(-2);
  strout += "00Z";
  return strout;
}

export default {
	props: {
		booking: Object
	},
	data: function() {
		return {
      msguser: undefined,
      calendars: undefined,
      directions: undefined
		}
	},
	created: async function() {
    const booking = this.booking;
    const direction = `https://www.google.com/maps/dir/Current+Location/${booking.property.address.latitude},${booking.property.address.longitude}`;
    const cal_title = encodeURIComponent('Viewing '+booking.property.address.buildingNumber+' '+booking.property.address.street);
    const fulladdr = `${booking.property.address.buildingNumber} ${booking.property.address.street}, ${booking.property.address.town}, ${booking.property.address.county}, ${booking.property.address.postcode}`;
    const cal_addr = encodeURIComponent(fulladdr);
    let cal_specs = `${fulladdr}\n`;
    if (booking.iam == 'inviter') {
      if (booking.booking.profileExtra.name) {
        cal_specs += `${booking.booking.profileExtra.name}\n`;
        if (booking.booking.profileExtra.phone) {
          cal_specs += `${booking.booking.profileExtra.phone}\n`;
        }
      } else if (booking.user) {
        cal_specs += `${booking.user.fullName}\n`;
        if (booking.user.phone) {
          cal_specs += `${booking.user.phone}\n`;
        }
      }
    } else {
      cal_specs += `${booking.agent.name}\n`;
      cal_specs += `${booking.agent.phone ? booking.agent.phone : ''}\n`;
    }

    cal_specs += "\nDirections:\n"+direction;
    cal_specs = encodeURIComponent(cal_specs);

    this.calendars = {
      "ical": `${this.config.services.booking}/webcal/${this.$parent.trackId}/${this.$parent.userId}`,
      "outlook": `${this.config.services.booking}/webcal/${this.$parent.trackId}/${this.$parent.userId}`,
      "google": `http://www.google.com/calendar/event?location=${cal_addr}&action=TEMPLATE&sprop=name%3A${encodeURIComponent(booking.company.companyName)}&sprop=website%3A${encodeURIComponent(window.location.href)}&details=${cal_specs}&text=${cal_title}&dates=${dtstamp(booking.booking.date_suggested)}%2F${dtstamp(parseInt(booking.booking.date_suggested) + 900000)}`,
      "yahoo": `http://calendar.yahoo.com/?in_loc=${cal_addr}&v=60&VIEW=d&TYPE=20&TITLE=${cal_title}&ST=${dtstamp(booking.booking.date_suggested)}&DUR=0015&URL=${encodeURIComponent(window.location.href)}&DESC=${cal_specs}`
    };
    this.directions = direction;

    this.processActions();
  },
	methods: {
    async processActions(forceaction,forceparams) { // App actions for GET and Live inputs
			const validatePath = window.location.pathname.split('/');
			const params = forceparams ? forceparams : this.$parent.params;
			if ((!this.$parent.action && !forceaction)) {
				return false;
			}
      const hasGET = validatePath[4] ? true : false;
			const cleanPath = `/${validatePath[1]}/${validatePath[2]}/${validatePath[3]}`;
      const action = forceaction ? forceaction : this.$parent.action;

      // Pre-render action
			const oldbooking = this.booking;
      if (action == 'cancel') {
        //if (confirm('Are you sure you want to cancel this viewing?') === false) {
        //  return true;
        //}
        this.$parent.phase = 'closed';
        this.booking.booking.phase = 'closed';
        this.booking.booking.status = 'cancelled';
        this.$parent.booking.booking.phase = 'closed';
        this.$parent.booking.booking.status = 'cancelled';
      } else if (action == 'webcal') {
        window.location.href = this.calendars.ical;
        return true;
      } else if (action == 'confirm') {
        this.$parent.booking.booking.status = 'justconfirmed';

      }

      let bookingUpdate;
      try {
        switch(action) {
          case "confirm":
           bookingUpdate = await api({endpoint: this.config.services.booking, path: '/bookingConfirmation/'+this.$parent.trackId+'/'+this.$parent.userId, method: 'POST', body: {
             action: "confirm"
           }});
           break;
          case "later":
           bookingUpdate = await api({endpoint: this.config.services.booking, path: '/bookingConfirmation/'+this.$parent.trackId+'/'+this.$parent.userId, method: 'POST', body: {
             action: "later",
             interval: params
           }});
           break;
          case "cancel":
           bookingUpdate = await api({endpoint: this.config.services.booking, path: '/cancel/'+this.$parent.trackId+'/'+this.$parent.userId, method: 'GET'});
           break;
          default:

           break;
        }
      } catch(e) {
        console.log(e.message);
        if (hasGET)window.location.pathname = cleanPath;
      }

      if (!bookingUpdate) { // Error
				this.booking = oldbooking;
				this.$parent.booking = oldbooking;
				this.$parent.phase = oldbooking.booking.phase;
        return false;
      } else {
        if (action == 'cancel') {
          //this.msgUser('Booking view cancelled.');
          //setTimeout(function(){
          //  window.location.pathname = cleanPath;
          //},2000);
        } else if (action == 'later') {
          this.$parent.booking.booking.date_remember = (new Date().getTime() + (parseInt(params) * (60*1000)));
          this.booking.booking.date_remember = (new Date().getTime() + (parseInt(params) * (60*1000)));
          this.msgUser('You will be reminded, '+niceDateAt(this.$parent.booking.booking.date_remember));
        }
      }

    },
    msgUser(msg) {
      this.msguser = msg;
    },
    niceValue(value) {
      let kk = '';
      if (value.toString().length > 3) {
        kk = 'k';
      } else if (value.toString().length > 6) {
        kk = 'kk';
      }
      return value.toString().substr(0,3)+kk;
    },
    niceDateAt(datetime,nohours,withminutes) {
      const dt = this.niceDate(datetime,nohours,withminutes);
      if (dt.indexOf('Today') !== -1 || dt.indexOf('Tomorrow') !== -1) {
        return dt;
      } else {
        return 'on '+dt;
      }
    },
    niceDate(datetime,nohours,withminutes) {
      var notnow = new Date(datetime);
      var now = new Date();
      var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','October','Nov','Dec'];

      var day = days[ notnow.getDay() ];
      var month = months[ notnow.getMonth() ];

      var date = notnow.getDate();
      var hours = notnow.getHours();
      var ampm = hours >= 12 ? ' pm' : ' am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      var dateString = '';
      if (notnow.getDay() == now.getDay() && notnow.getMonth() == now.getMonth() && notnow.getFullYear() == now.getFullYear()) {
        dateString += "Today";
      }
      else if (notnow.getDay() == (now.getDay()+1) && notnow.getMonth() == now.getMonth() && notnow.getFullYear() == now.getFullYear()) {
        dateString += "Tomorrow";
      } else {
        dateString += day+" " +date;
        dateString += (now.getMonth() == notnow.getMonth()) ? '' : ', '+month;
      }
      if (!nohours) {
        let reDatehour = '';
        reDatehour += " "+hours;
        if (parseInt(notnow.getMinutes()) != 0)
          reDatehour += ":"+notnow.getMinutes();
        reDatehour += " "+ampm;
        dateString = dateString+" at "+reDatehour;
      }

      return dateString;
    },
    getCal(type) {
      if (this.calendars[type])
       window.location.href = this.calendars[type];
    },
    getDirections() {
       window.location.href = this.directions;
    },
		getAddress(full,buildingnr,county,town,postcode) {
			let ret = '';
      if (full || buildingnr) {
        ret += this.booking.property.address.buildingNumber;
      }
      if (ret != '')ret += ' ';
			ret += this.booking.property.address.street;
			if (full || county) {
				if (ret != '')ret += ', ';
				ret += this.booking.property.address.county;
			}
			if (full || town) {
				if (ret != '')ret += ', ';
				ret += this.booking.property.address.town;
			}
			if (full || postcode) {
				if (ret != '')ret += ', ';
				ret += this.booking.property.address.postcode;
			}
      return ret;
		}
  }
}
</script>
<style>
  @media screen and (max-width: 839px) and (min-width: 793px) {
    .booking__calendar_root {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .booking__calendar-btn {
      width: 90px;
      padding: 8px 45px;
      margin: 20px;
      vertical-align: middle
    }
  }
  @media screen and (max-width: 792px) and (min-width: 392px) {
    .booking__calendar_root {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .booking__calendar-btn {
      width: 90px;
      padding: 8px 35px;
      margin: 20px;
      vertical-align: middle
    }
  }
  @media screen and (max-width: 391px) {
    .booking__calendar_root {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .booking__calendar-btn {
      width: 70px;
      padding: 8px 25px;
      margin: 20px;
      vertical-align: middle
    }
  }
  @media screen and (max-width: 522px) {
    .container-white {
      padding: var(--mdc-layout-grid-margin-desktop, 3.4375rem);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/booking/confirmation.vue